import { render, staticRenderFns } from "./ManagerRatingPage.vue?vue&type=template&id=5984e850&"
import script from "./ManagerRatingPage.vue?vue&type=script&lang=ts&"
export * from "./ManagerRatingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports